
import {makeApiServerRequest} from "../../stores/serverConnection/makeApiServerRequest";
import {WsServerConnection} from "../../stores/serverConnection/wsServerConnection";
import {recordLimitHit} from "../../utils/googleTagManager";

import {METRIC_ACTION} from './common';


export const registerQuizVisit = (wsServerConnection: WsServerConnection) => {
    return makeApiServerRequest(wsServerConnection, `m/${METRIC_ACTION.QUIZ_VISIT}`);
}

export const registerQuizCreate = (wsServerConnection: WsServerConnection) => {
    return makeApiServerRequest(wsServerConnection, `m/${METRIC_ACTION.QUIZ_CREATE}`);
}

export const registerSearchRequest = (wsServerConnection: WsServerConnection) => {
    return makeApiServerRequest(wsServerConnection, `m/${METRIC_ACTION.SEARCH_EXECUTE}`);
}

export const registerLimitBreach = (wsServerConnection: WsServerConnection, limitType: 'location' | 'user' | 'storage' = 'location') => {
    recordLimitHit(limitType);
    return makeApiServerRequest(wsServerConnection, `m/${METRIC_ACTION.LIMIT_BREACH}`, { limitType });
}

export const notifyFeatureFirstUsed = (wsServerConnection: WsServerConnection, feature: string) => {
    return makeApiServerRequest(wsServerConnection, `m/${METRIC_ACTION.FEATURE_FIRST_USED}`, { feature });
}
